import { httpClient } from "@services/api/httpClient";


export async function getOfferAssesmentByOffer(offerUUID: string) {
  const response = await httpClient.get("/offer-assesment/by-offer", {
    params: { offerUUID }
  });
  return response.data;
}